type CompositionProp = string | React.ReactNode;

interface ClassNameProp {
	className?: string;
}

const sizesArray = ['xs', 'sm', 'md', 'lg', 'xl'] as const;

type Sizes = (typeof sizesArray)[number];

type BooleanOrPredicate<T> = boolean | ((value: T) => boolean);

export { CompositionProp, ClassNameProp, Sizes, sizesArray, BooleanOrPredicate };
